import React from 'react';

import ToolTip from 'common/components/ToolTip';
import Icon from 'common/components/Icon';
import colors from 'common/styles/colors';
import { offRampSupportUrl } from 'common/constants';

import styles from './index.module.css';

const OffRampsHeading = () => (
  <div className={styles.root}>
    Off ramps
    <ToolTip
      message={
        <div className={styles.tooltipContent}>
          Convert your crypto funds into
          <br />
          your settlement currency.
          <a
            className={styles.learnMoreLink}
            href={offRampSupportUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn more ↗
          </a>
        </div>
      }
    >
      <Icon.Info
        className={styles.infoIcon}
        description="What is this page about?"
        size="medium"
        fill={colors['rebranding-md-color-brand-purple']}
        circleStroke={colors['rebranding-md-color-brand-purple']}
      />
    </ToolTip>
  </div>
);

export default OffRampsHeading;
